import vis from 'visjs-network';
import 'visjs-network/lib/shared/tooltip.css';
import 'visjs-network/dist/vis-network.min.css';

let network_array = [];

const network_graph = {
  draw (container_id, nodes, edges, options, chart_name) {
    let node_objects = new vis.DataSet(nodes);
    let edge_objects = new vis.DataSet(edges);
    let container = document.getElementById(container_id);
    let data = {
      nodes: node_objects,
      edges: edge_objects
    };
    this.network = new vis.Network(container, data, options);
    network_array.push({[chart_name]: this.network});
    this.network_array = network_array;
    this.network.fit();
  },
  init (container_id, chart_name) {
    this.draw(container_id, gon[chart_name].nodes, gon[chart_name].edges, gon[chart_name].options, chart_name);
  },
  network_array_delete () {
    network_array = []
  },
}

export default network_graph;
